// @generated by protoc-gen-es v2.10.1 with parameter "target=ts"
// @generated from file bffuser/v1/demand_confirm_record_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AreaCode } from "../../bfftypes/v1/area_pb";
import { file_bfftypes_v1_area } from "../../bfftypes/v1/area_pb";
import type { ConfirmCategory, DemandConfirmRecordSummary, PlanningSection } from "./demand_confirm_record_model_pb";
import { file_bffuser_v1_demand_confirm_record_model } from "./demand_confirm_record_model_pb";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file bffuser/v1/demand_confirm_record_service.proto.
 */
export const file_bffuser_v1_demand_confirm_record_service: GenFile = /*@__PURE__*/
  fileDesc("Ci5iZmZ1c2VyL3YxL2RlbWFuZF9jb25maXJtX3JlY29yZF9zZXJ2aWNlLnByb3RvEgpiZmZ1c2VyLnYxIrICCh9MaXN0RGVtYW5kQ29uZmlybVJlY29yZHNSZXF1ZXN0EkYKF3BsYW5uaW5nX3NlY3Rpb25fZmlsdGVyGAMgASgOMhsuYmZmdXNlci52MS5QbGFubmluZ1NlY3Rpb25CCLpIBYIBAhABEj4KEGFyZWFfY29kZV9maWx0ZXIYBCABKA4yFS5iZmZ0eXBlcy52MS5BcmVhQ29kZUIIukgFggECEAFIAIgBARJGChdjb25maXJtX2NhdGVnb3J5X2ZpbHRlchgFIAEoDjIbLmJmZnVzZXIudjEuQ29uZmlybUNhdGVnb3J5Qgi6SAWCAQIQARIeCgdiZ19jb2RlGAcgASgJQgi6SAVyA5gBBUgBiAEBQhMKEV9hcmVhX2NvZGVfZmlsdGVyQgoKCF9iZ19jb2RlIlsKIExpc3REZW1hbmRDb25maXJtUmVjb3Jkc1Jlc3BvbnNlEjcKB3JlY29yZHMYASADKAsyJi5iZmZ1c2VyLnYxLkRlbWFuZENvbmZpcm1SZWNvcmRTdW1tYXJ5MpUBChpEZW1hbmRDb25maXJtUmVjb3JkU2VydmljZRJ3ChhMaXN0RGVtYW5kQ29uZmlybVJlY29yZHMSKy5iZmZ1c2VyLnYxLkxpc3REZW1hbmRDb25maXJtUmVjb3Jkc1JlcXVlc3QaLC5iZmZ1c2VyLnYxLkxpc3REZW1hbmRDb25maXJtUmVjb3Jkc1Jlc3BvbnNlIgBCQFo+Z2l0aHViLmNvbS9lbmVjaGFpbi9lYmFsYW5jZS9nby9nZW4vcHJvdG8vYmZmdXNlci92MTtiZmZ1c2VydjFiBnByb3RvMw", [file_bfftypes_v1_area, file_bffuser_v1_demand_confirm_record_model, file_buf_validate_validate]);

/**
 * ListDemandConfirmRecordsRequest carries no organization_id; the BFF
 * handler resolves the organization from the eauth session.
 *
 * @generated from message bffuser.v1.ListDemandConfirmRecordsRequest
 */
export type ListDemandConfirmRecordsRequest = Message<"bffuser.v1.ListDemandConfirmRecordsRequest"> & {
  /**
   * planning_section_filter narrows results to a specific planning
   * section. UNSPECIFIED (= 0) means no filter (all sections).
   *
   * @generated from field: bffuser.v1.PlanningSection planning_section_filter = 3;
   */
  planningSectionFilter: PlanningSection;

  /**
   * area_code_filter narrows results to a specific area.
   * UNSPECIFIED (= 0) means no filter (all areas).
   *
   * @generated from field: optional bfftypes.v1.AreaCode area_code_filter = 4;
   */
  areaCodeFilter?: AreaCode;

  /**
   * confirm_category_filter narrows results to a specific category.
   * UNSPECIFIED (= 0) means no filter (all categories).
   *
   * @generated from field: bffuser.v1.ConfirmCategory confirm_category_filter = 5;
   */
  confirmCategoryFilter: ConfirmCategory;

  /**
   * bg_code narrows results to a specific submission-responsible BG (OCCTO
   * 5-char code). Unset means no filter. frontend resolves this from
   * useGetWorkflowCase(caseId).bgCode (demand-confirm-record-bg-axis Design
   * Note Decision #4).
   *
   * @generated from field: optional string bg_code = 7;
   */
  bgCode?: string;
};

/**
 * Describes the message bffuser.v1.ListDemandConfirmRecordsRequest.
 * Use `create(ListDemandConfirmRecordsRequestSchema)` to create a new message.
 */
export const ListDemandConfirmRecordsRequestSchema: GenMessage<ListDemandConfirmRecordsRequest> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_service, 0);

/**
 * @generated from message bffuser.v1.ListDemandConfirmRecordsResponse
 */
export type ListDemandConfirmRecordsResponse = Message<"bffuser.v1.ListDemandConfirmRecordsResponse"> & {
  /**
   * @generated from field: repeated bffuser.v1.DemandConfirmRecordSummary records = 1;
   */
  records: DemandConfirmRecordSummary[];
};

/**
 * Describes the message bffuser.v1.ListDemandConfirmRecordsResponse.
 * Use `create(ListDemandConfirmRecordsResponseSchema)` to create a new message.
 */
export const ListDemandConfirmRecordsResponseSchema: GenMessage<ListDemandConfirmRecordsResponse> = /*@__PURE__*/
  messageDesc(file_bffuser_v1_demand_confirm_record_service, 1);

/**
 * DemandConfirmRecordService provides Connect RPCs for reading demand
 * confirm record history (確定履歴). All RPCs are read-only.
 *
 * @generated from service bffuser.v1.DemandConfirmRecordService
 */
export const DemandConfirmRecordService: GenService<{
  /**
   * ListDemandConfirmRecords returns the list of demand confirm records
   * that match the supplied filters, sorted by confirmed_at descending.
   *
   * @generated from rpc bffuser.v1.DemandConfirmRecordService.ListDemandConfirmRecords
   */
  listDemandConfirmRecords: {
    methodKind: "unary";
    input: typeof ListDemandConfirmRecordsRequestSchema;
    output: typeof ListDemandConfirmRecordsResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_bffuser_v1_demand_confirm_record_service, 0);

